import * as React from "react";
import Modal, { IModalProps } from "../../../components/modal/modal";

export interface IBookReadingModalProps extends IModalProps {
    playerLink?: string;
}

const BookReadingModal: React.FC<IBookReadingModalProps> = ({ playerLink, ...rest }) => {
    return (
        <Modal className="book-reading-modal" {...rest}>
            <iframe src={playerLink} />
        </Modal>
    );
};

export default BookReadingModal;
